const initialState = {
  timeLineObjects: [],
  relatedEntities: [],
  tabIdsToDisplay: [],
  EntityType: null,
  EntityIdentifier: null,
  objectProperties: {},
  staticAnalysisResults: {},
  globalSelectedRows: [],
  selectedTab: 0,
  objectRelatedInformation: {},
  remoteIps: [],
  chosenAlerts: [],
  newAlertsStatus: -1,
  fileGlobalState: 0,

  hasCheckBoxSearchTableData: true
};

export default initialState;
